/**
 * @file popup.ts
 * @module app/modules/_common/components/pop-up/popup
 * @description Aggregated utility for displaying various types of popups (info, success, error, warning) and closing them.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.1
 * @version 2.1.2
 */

import showInfoPopup from './info-popup';
import showSuccessPopup from './success-popup';
import showErrorPopup from './error-popup';
import showWarningPopup from './warning-popup';
import showConfirmPopup from './confirm-popup';
import { closePopup } from './popup-service';

const Popup = {
  info: showInfoPopup,
  success: showSuccessPopup,
  error: showErrorPopup,
  warning: showWarningPopup,
  confirm: showConfirmPopup,
  close: closePopup,
};

export default Popup;